import React from 'react';
import { useNavigate } from 'react-router-dom';
import UseWelcomeNavbarStyle from './welcome-navigation-bar.styles';

interface WelcomeNavigationBarProps {
  onNext?: React.MouseEventHandler;
  hideBackButton?: boolean;
  disabled?: boolean;
  buttonLabel: string;
}

export const WelcomeNavigationBar: React.FC<WelcomeNavigationBarProps> = ({ onNext, hideBackButton, disabled, buttonLabel }) => {
  const classes = UseWelcomeNavbarStyle();
  const navigate = useNavigate();

  const goBack = (): void => {
    navigate(-1);
  };

  const nextButtonLabel = buttonLabel || 'Next';

  return (
    <div className={`${classes.welcome__navigation} ${hideBackButton ? classes.welcome__navigation__align__right : ''}`}>
      { !hideBackButton
        && <button type="button" className={classes.welcome__navigation__back} onClick={goBack}>Back</button>}
      <button type="button" data-cy="next-btn" className={`${classes.welcome__navigation__next} margin__left__auto`} onClick={onNext} disabled={disabled}>{nextButtonLabel}</button>
    </div>

  );
};

